import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '仪表盘', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/list',
    meta: { title: '用户管理', icon: 'el-icon-user' },
    children: [
      {
        path: 'list',
        name: 'UserList',
        component: () => import('@/views/user/list.vue'),
        meta: { title: '用户列表' }
      },
      {
        path: 'detail/:id',
        name: 'UserDetail',
        component: () => import('@/views/user/detail.vue'),
        meta: { title: '用户详情' },
        hidden: true
      }
    ]
  },
  {
    path: '/recyclerManage',
    component: Layout,
    redirect: '/recycler/list',
    meta: { title: '回收人员管理', icon: 'el-icon-s-shop' },
    children: [
      {
        path: 'list',
        name: 'RecyclerList',
        component: () => import('@/views/recyclerManage/list.vue'),
        meta: { title: '回收人员列表' }
      }
    ]
  },
  {
    path: '/recycleCategory',
    component: Layout,
    redirect: '/recycleCategory/list',
    meta: { title: '回收分类管理', icon: 'el-icon-s-grid' },
    children: [
      {
        path: 'list',
        name: 'CategoryList',
        component: () => import('@/views/recycleCategory/list.vue'),
        meta: { title: '回收分类列表' }
      }
    ]
  },
  {
    path: '/recycleGoods',
    component: Layout,
    redirect: '/recycleGoods/list',
    meta: { title: '回收物品管理', icon: 'el-icon-goods' },
    children: [
      {
        path: 'list',
        name: 'GoodsList',
        component: () => import('@/views/recycleGoods/list.vue'),
        meta: { title: '回收物品列表' }
      }
    ]
  },
  {
    path: '/recycleOrder',
    component: Layout,
    redirect: '/recycleOrder/list',
    meta: { title: '回收订单管理', icon: 'el-icon-s-order' },
    children: [
      {
        path: 'list',
        name: 'OrderList',
        component: () => import('@/views/recycleOrder/list.vue'),
        meta: { title: '回收订单' }
      },
      {
        path: 'detail/:id',
        name: 'OrderDetail',
        component: () => import('@/views/recycleOrder/detail.vue'),
        meta: { title: '订单详情' },
        hidden: true
      }
    ]
  },
  {
    path: '/merchant',
    component: Layout,
    redirect: '/merchant/list',
    meta: { title: '商户管理', icon: 'el-icon-s-order' },
    children: [
      {
        path: 'list',
        name: 'MerchantList',
        component: () => import('@/views/points-merchant/audit.vue'),
        meta: { title: '商户列表' }
      },
      {
        path: 'withdrawals',
        name: 'withdrawals',
        component: () => import('@/views/points-merchant/withdrawals.vue'),
        meta: { title: '提现管理' },
      }
    ]
  },
  {
    path: '/mall',
    component: Layout,
    redirect: '/mall/publicGoods',
    meta: { title: '积分商城', icon: 'el-icon-present' },
    children: [
      {
        path: 'publicGoods',
        name: 'MallGoods',
        component: () => import('@/views/mall/publicGoods.vue'),
        meta: { title: '公共商品' }
      },
	  {
	    path: 'privateGoods',
	    name: 'MallGoods',
	    component: () => import('@/views/mall/privateGoods.vue'),
	    meta: { title: '商户商户' }
	  },
      {
        path: 'orders',
        name: 'MallOrders',
        component: () => import('@/views/mall/orders.vue'),
        meta: { title: '积分订单' }
      },
      {
        path: 'categories',
        name: 'MallCategories',
        component: () => import('@/views/mall/categories.vue'),
        meta: { title: '商品分类' }
      }
    ]
  },
  {
    path: '/checkin',
    component: Layout,
    redirect: '/checkin/rules',
    meta: { title: '签到配置', icon: 'el-icon-date' },
    children: [
      {
        path: 'rules',
        name: 'CheckinRules',
        component: () => import('@/views/checkin/rules.vue'),
        meta: { title: '签到规则' }
      }
    ]
  },
  {
    path: '/banner',
    component: Layout,
    redirect: '/banner/list',
    meta: { title: '轮播图', icon: 'el-icon-picture' },
    children: [
      {
        path: 'list',
        name: 'BannerList',
        component: () => import('@/views/banner/list.vue'),
        meta: { title: '轮播图列表' }
      }
    ]
  },
  {
    path: '/system',
    component: Layout,
    redirect: '/system/admin',
    meta: { title: '系统设置', icon: 'el-icon-setting' },
    children: [
      // {
      //   path: 'config',
      //   name: 'SystemConfig',
      //   component: () => import('@/views/system/config.vue'),
      //   meta: { title: '系统配置' }
      // },
      {
        path: 'admin',
        name: 'AdminList',
        component: () => import('@/views/admin/list.vue'),
        meta: { title: '管理员管理' }
      }
    ]
  },
  {
    path: '*',
    redirect: '/dashboard'
  }
]

const router = new VueRouter({
  routes
})

export default router
